import { TeliaCtaLink, TeliaGrid, TeliaHeading } from '@teliads/components/react';
import './ContentBannerPurPur.scss';
import { ReactElement } from 'react';

import BaseTag from '../base-tag/BaseTag';

import { getLinkTarget } from 'utils/utils';

type Props = {
  imgSrc: string;
  imgAlt: string;
  imgPosition?: 'left' | 'right';
  negative?: boolean;
  badge?: string;
  title: string;
  preamble: ReactElement;
  variant?: 'lg' | 'md';
  cta?: {
    href: string;
    name: string;
  };
};

const ContentBannerPurPur = ({
  preamble,
  imgSrc,
  imgAlt,
  variant = 'lg',
  badge,
  title,
  cta,
  negative = false,
  imgPosition = 'right',
}: Props) => {
  const flexDirectionClass = imgPosition === 'left' ? 'flex-row' : 'flex-row-reverse';
  const negativeBackground = negative ? 'negative' : '';

  return (
    <TeliaGrid>
      <div
        className={`content-banner-purpur-${variant} ${flexDirectionClass} ${negativeBackground}`}
        data-testid="content-banner"
      >
        <div className="content-banner-purpur__image-container">
          <img src={imgSrc} alt={imgAlt}></img>
        </div>

        <div className="content-banner-purpur__content">
          {badge && (
            <span data-testid="content-banner-badge">
              <BaseTag text={badge} />
            </span>
          )}

          <TeliaHeading variant="title-300" tag="h3">
            {title}
          </TeliaHeading>

          <div>{preamble}</div>

          {cta && (
            <div data-testid="content-banner-cta">
              <TeliaCtaLink href={cta.href} target={getLinkTarget(cta.href)} variant="expressive">
                {cta.name}
              </TeliaCtaLink>
            </div>
          )}
        </div>
      </div>
    </TeliaGrid>
  );
};

export default ContentBannerPurPur;
